import React from "react";

import "./shimmer.scss";

export const Shimmer = ({name}) => {

    return (
        <div className={`shimmer-qpr010 ${name}`}/>
    )
}